import tracker from '../../../../service/tracker';
import { EVENTS_MAPPING, NSC_PATH_MAPPER } from '../../../../utils/constants';

export const handleClick = (path) => {
    const event = EVENTS_MAPPING.CLICK.TARGETS[NSC_PATH_MAPPER[path]];

    tracker.click(event);
};
